import React from "react"

import Nav from "./nav.js"
import Logo from "./logo.js"
import Powered from "./powered.js"

import style from "./header.module.css"

const Header = () => (
	<header>
		<div className={style.content}>
			<Nav />
			<Logo />
			<div className={style.coordinates}>
				<p className={style.location}>Karlsruhe</p>
				<p className={style.date}>24. / 25. SEP 2019</p>
			</div>
			<div className={style.topic}>
				<p>
					Conference Topic
					<br />
					Quick &amp; Dirty
				</p>
			</div>
			<div className={style.powered}>
				<Powered />
			</div>
		</div>
	</header>
)

export default Header
